module.exports = __webpack_public_path__ + "img/couples-076.e7ef6df1.jpg";